import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import {
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE,
  MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE,
} from "../../../i18n/keysTranslations";
import {
  GRAY_100,
  INPUT_COLOR_BORDER,
  BOX_SHADOW_THEME,
} from "../../../utils/colors";
import {
  BORDER_RADIUS,
  PURCHASE_VIDEO_EXAMPLES,
} from "../../../utils/constants";
import ModalMedia from "../ModalMedia";

const VideoPurchaseExamples = () => {
  const { t } = useTranslationApp();
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);

  const onSelectVideo = ({ url }) => {
    setSelectedVideoUrl(url);
  };

  const onCloseVideoModal = () => {
    setSelectedVideoUrl(null);
  };

  return (
    <>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          px: 2,
          py: 1.5,
          mt: 1,
          borderRadius: BORDER_RADIUS,
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: BOX_SHADOW_THEME,
        })}
      >
        <Typography
          sx={{
            fontSize: "0.875rem",
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {t(MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE)}
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${PURCHASE_VIDEO_EXAMPLES.length}, 1fr)`,
            gap: 1,
          }}
        >
          {PURCHASE_VIDEO_EXAMPLES.map((url, index) => (
            <Box
              key={url}
              component="button"
              type="button"
              onClick={() => onSelectVideo({ url })}
              sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 1.5,
                borderRadius: BORDER_RADIUS,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                bgcolor: GRAY_100,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: theme.palette.action.hover,
                },
              })}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  color: "text.primary",
                }}
              >
                {t(MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE, {
                  number: index + 1,
                })}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {selectedVideoUrl && (
        <ModalMedia
          modalOpen={!!selectedVideoUrl}
          onCloseModal={onCloseVideoModal}
          url={selectedVideoUrl}
          showEditButton={false}
          showDownloadButton={false}
          showShareButton={false}
          showDeleteButton={false}
        />
      )}
    </>
  );
};

export default VideoPurchaseExamples;
